export type TranslationKey = keyof typeof translations.zh;

export const translations = {
  zh: {
    // Navigation
    navServices: '服务项目',
    navAbout: '关于我们',
    navTestimonials: '客户评价',
    navContact: '联系我们',
    navMenu: '导航菜单',
    navMenuDesc: '选择您要访问的页面',
    navOpenMenu: '打开菜单',
    
    // Hero
    heroTitle1: '悉尼专业',
    heroTitle2: '搬家服务',
    heroSubtitle: '家家顺搬家',
    heroDescription: '我们为悉尼及周边地区的家庭和企业提供可靠、高效和实惠的专业搬家服务',
    heroTag1: '🏠 居民搬家',
    heroTag2: '🏢 办公室搬迁',
    heroTag3: '🎹 特殊物品搬运',
    heroCTA1: '免费获取报价',
    heroCTA2: '查看服务项目',
    heroRating: '5星好评',
    
    // Services
    servicesTitle: '我们的服务',
    servicesSubtitle: '在悉尼为您提供全方位的专业搬家服务',
    serviceResidential: '居民搬家服务',
    serviceResidential1: '悉尼市内及周边地区的快速、安全搬家服务',
    serviceResidential2: '从悉尼到墨尔本、布里斯班等地的跨州搬家',
    serviceResidential3: '提供国际搬家服务，包括海运和空运',
    serviceResidential4: '针对悉尼高层公寓的专业搬家服务',
    serviceResidential5: '为悉尼留学生提供经济实惠的搬家方案',
    serviceOffice: '办公室搬迁服务',
    serviceOffice1: '适合悉尼中小企业的快速搬迁服务',
    serviceOffice2: '为悉尼大型企业提供一站式搬迁解决方案',
    serviceOffice3: '专业搬运办公设备，如电脑、打印机等',
    serviceOffice4: '为悉尼本地仓库提供高效搬迁服务',
    serviceSpecial: '特殊物品搬运',
    serviceSpecial1: '专业钢琴搬运团队，确保贵重乐器安全无损',
    serviceSpecial2: '为悉尼艺术收藏家提供定制化艺术品搬运服务',
    serviceSpecial3: '包括跑步机、举重设备等大型健身器材的搬运',
    serviceSpecial4: '针对贵重古董家具的精细搬运服务',
    servicePacking: '打包与拆装服务',
    servicePacking1: '提供高质量打包材料，确保物品安全',
    servicePacking2: '拆卸和重新组装家具，如床、衣柜、桌子等',
    servicePacking3: '包括电视、洗衣机、冰箱等电器的安装服务',
    servicePacking4: '为悉尼客户提供短期或长期的物品存储解决方案',
    serviceCleaning: '清洁服务',
    serviceCleaning1: '为旧居提供搬家前深度清洁服务',
    serviceCleaning2: '为新居提供搬家后清洁服务，确保入住时干净整洁',
    serviceCleaning3: '专业地毯清洁服务，适合悉尼家庭和办公室',
    serviceCustom: '定制化服务',
    serviceCustom1: '为忙碌的悉尼客户提供周末搬家服务',
    serviceCustom2: '快速响应，满足紧急搬家需求',
    serviceCustom3: '使用环保材料和车辆，减少搬家过程中的碳排放',
    serviceSydney: '悉尼特色服务',
    serviceSydney1: '针对悉尼老城区狭窄街道的专业搬家方案',
    serviceSydney2: '为悉尼沿海地区提供特殊搬家服务',
    serviceSydney3: '为悉尼蓝山地区提供定制化搬家服务',
    
    // About
    aboutTitle: '关于家家顺搬家',
    aboutDescription: '拥有超过10年的行业经验，家家顺搬家公司已成为悉尼地区值得信赖的专业搬家服务提供商。我们的团队由经验丰富的专业人员组成，他们会细心谨慎地处理您的所有物品。',
    aboutWhyTitle: '为什么选择我们？',
    aboutWhy1: '全面保险及合法执照',
    aboutWhy2: '现代化车队',
    aboutWhy3: '经验丰富的专业员工',
    aboutWhy4: '定制化解决方案',
    aboutWhy5: '七天客户支持服务',
    aboutCTA: '获取免费报价',
    
    // Testimonials
    testimonialsTitle: '客户评价',
    testimonialsSubtitle: '不只是我们的说法，听听满意客户的真实反馈。',
    testimonialsGoogle: 'Google 客户好评',
    testimonialsFrom: '来自 Google',
    testimonialsReviews: '条评价',
    
    // Contact
    contactTitle: '获取免费报价',
    contactSubtitle: '只需几分钟填写信息，我们的专家将为您提供一份详细且无隐藏费用的报价。',
    contactInfo: '联系信息',
    contactPhone: '电话',
    contactEmail: '邮箱',
    contactHours: '营业时间',
    contactHoursWeekday: '周一至周六: 8:00 AM - 6:00 PM',
    contactHoursWeekend: '周日: 预约服务',
    contactFormName: '姓名',
    contactFormNamePlaceholder: '请输入您的姓名',
    contactFormPhone: '电话',
    contactFormPhonePlaceholder: '请输入您的电话',
    contactFormEmail: '邮箱',
    contactFormEmailPlaceholder: '请输入您的邮箱',
    contactFormMoveFrom: '搬出地址',
    contactFormMoveFromPlaceholder: '请输入搬出地址',
    contactFormMoveTo: '搬入地址',
    contactFormMoveToPlaceholder: '请输入搬入地址',
    contactFormMessage: '其他需求',
    contactFormMessagePlaceholder: '请描述您的其他需求...',
    contactFormSpam: '验证问题（防垃圾邮件）',
    contactFormSpamError: '验证答案不正确，请重新计算',
    contactFormSubmit: '发送信息',
    contactFormSubmitting: '正在提交...',
    contactFormSuccess: '感谢您的留言！',
    contactFormSuccessDesc: '我们会尽快与您联系。',
    
    // Footer
    footerDescription: '为悉尼及周边地区的居民和商业客户提供专业、高效、可靠的搬家服务。',
    footerServices: '服务项目',
    footerResidential: '居民搬家',
    footerOffice: '办公室搬迁',
    footerSpecial: '特殊物品搬运',
    footerPacking: '打包与拆装',
    footerCompany: '公司信息',
    footerAbout: '关于我们',
    footerTestimonials: '客户评价',
    footerContact: '联系我们',
    footerPrivacy: '隐私政策',
    footerContactInfo: '联系方式',
    footerCopyright: 'All rights reserved.',
    footerPoweredBy: '网站由 Flex Solutions 设计开发',
  },
  en: {
    // Navigation
    navServices: 'Services',
    navAbout: 'About Us',
    navTestimonials: 'Testimonials',
    navContact: 'Contact Us',
    navMenu: 'Navigation Menu',
    navMenuDesc: 'Select the page you want to visit',
    navOpenMenu: 'Open menu',
    
    // Hero
    heroTitle1: 'Professional Sydney',
    heroTitle2: 'Removal Services',
    heroSubtitle: 'Michael Removalist',
    heroDescription: 'We provide reliable, efficient and affordable professional removal services for families and businesses in Sydney and surrounding areas',
    heroTag1: '🏠 Residential Moving',
    heroTag2: '🏢 Office Relocation',
    heroTag3: '🎹 Special Items Moving',
    heroCTA1: 'Get Free Quote',
    heroCTA2: 'View Services',
    heroRating: '5 Star Rating',
    
    // Services
    servicesTitle: 'Our Services',
    servicesSubtitle: 'Comprehensive professional removal services in Sydney',
    serviceResidential: 'Residential Moving Services',
    serviceResidential1: 'Fast and safe moving services in Sydney and surrounding areas',
    serviceResidential2: 'Interstate moving from Sydney to Melbourne, Brisbane and other states',
    serviceResidential3: 'International moving services including sea and air freight',
    serviceResidential4: 'Professional moving services for high-rise apartments in Sydney',
    serviceResidential5: 'Affordable moving solutions for international students in Sydney',
    serviceOffice: 'Office Relocation Services',
    serviceOffice1: 'Fast relocation services for small and medium businesses in Sydney',
    serviceOffice2: 'One-stop relocation solutions for large enterprises in Sydney',
    serviceOffice3: 'Professional moving of office equipment such as computers and printers',
    serviceOffice4: 'Efficient relocation services for local warehouses in Sydney',
    serviceSpecial: 'Special Items Moving',
    serviceSpecial1: 'Professional piano moving team ensuring safe transport of valuable instruments',
    serviceSpecial2: 'Customised art moving services for art collectors in Sydney',
    serviceSpecial3: 'Moving of large fitness equipment including treadmills and weightlifting equipment',
    serviceSpecial4: 'Fine moving services for valuable antique furniture',
    servicePacking: 'Packing & Assembly Services',
    servicePacking1: 'High-quality packing materials to ensure item safety',
    servicePacking2: 'Disassembly and reassembly of furniture such as beds, wardrobes and tables',
    servicePacking3: 'Installation services for appliances including TVs, washing machines and refrigerators',
    servicePacking4: 'Short-term or long-term storage solutions for Sydney customers',
    serviceCleaning: 'Cleaning Services',
    serviceCleaning1: 'Deep cleaning services before moving out',
    serviceCleaning2: 'Post-move cleaning services to ensure a clean and tidy new home',
    serviceCleaning3: 'Professional carpet cleaning services for Sydney homes and offices',
    serviceCustom: 'Customised Services',
    serviceCustom1: 'Weekend moving services for busy Sydney customers',
    serviceCustom2: 'Quick response to meet urgent moving needs',
    serviceCustom3: 'Use of eco-friendly materials and vehicles to reduce carbon emissions during moving',
    serviceSydney: 'Sydney-Specific Services',
    serviceSydney1: 'Professional moving solutions for narrow streets in Sydney\'s old districts',
    serviceSydney2: 'Special moving services for Sydney\'s coastal areas',
    serviceSydney3: 'Customised moving services for Sydney\'s Blue Mountains region',
    
    // About
    aboutTitle: 'About Michael Removalist',
    aboutDescription: 'With over 10 years of industry experience, Michael Removalist has become a trusted professional removal service provider in Sydney. Our team consists of experienced professionals who will carefully handle all your belongings.',
    aboutWhyTitle: 'Why Choose Us?',
    aboutWhy1: 'Comprehensive Insurance & Licensed',
    aboutWhy2: 'Modern Fleet',
    aboutWhy3: 'Experienced Professional Staff',
    aboutWhy4: 'Customised Solutions',
    aboutWhy5: '7-Day Customer Support',
    aboutCTA: 'Get Free Quote',
    
    // Testimonials
    testimonialsTitle: 'Customer Testimonials',
    testimonialsSubtitle: 'Not just our words, hear real feedback from satisfied customers.',
    testimonialsGoogle: 'Google Customer Reviews',
    testimonialsFrom: 'From Google',
    testimonialsReviews: 'reviews',
    
    // Contact
    contactTitle: 'Get Free Quote',
    contactSubtitle: 'Just fill in the information in a few minutes, and our experts will provide you with a detailed quote with no hidden fees.',
    contactInfo: 'Contact Information',
    contactPhone: 'Phone',
    contactEmail: 'Email',
    contactHours: 'Business Hours',
    contactHoursWeekday: 'Monday to Saturday: 8:00 AM - 6:00 PM',
    contactHoursWeekend: 'Sunday: By appointment',
    contactFormName: 'Name',
    contactFormNamePlaceholder: 'Please enter your name',
    contactFormPhone: 'Phone',
    contactFormPhonePlaceholder: 'Please enter your phone number',
    contactFormEmail: 'Email',
    contactFormEmailPlaceholder: 'Please enter your email',
    contactFormMoveFrom: 'Moving From',
    contactFormMoveFromPlaceholder: 'Please enter moving from address',
    contactFormMoveTo: 'Moving To',
    contactFormMoveToPlaceholder: 'Please enter moving to address',
    contactFormMessage: 'Other Requirements',
    contactFormMessagePlaceholder: 'Please describe your other requirements...',
    contactFormSpam: 'Verification Question (Spam Protection)',
    contactFormSpamError: 'Verification answer is incorrect, please recalculate',
    contactFormSubmit: 'Send Message',
    contactFormSubmitting: 'Submitting...',
    contactFormSuccess: 'Thank you for your message!',
    contactFormSuccessDesc: 'We will contact you as soon as possible.',
    
    // Footer
    footerDescription: 'Providing professional, efficient and reliable removal services for residential and commercial customers in Sydney and surrounding areas.',
    footerServices: 'Services',
    footerResidential: 'Residential Moving',
    footerOffice: 'Office Relocation',
    footerSpecial: 'Special Items Moving',
    footerPacking: 'Packing & Assembly',
    footerCompany: 'Company Information',
    footerAbout: 'About Us',
    footerTestimonials: 'Testimonials',
    footerContact: 'Contact Us',
    footerPrivacy: 'Privacy Policy',
    footerContactInfo: 'Contact Information',
    footerCopyright: 'All rights reserved.',
    footerPoweredBy: 'Website powered & designed by Flex Solutions',
  },
};

export const getTranslation = (language: 'zh' | 'en', key: string): string => {
  return translations[language][key as keyof typeof translations.zh] || key;
};

